import React from 'react';
import { UserAuth } from '../context/AuthContext';
import RoleSelection from './RoleSelection';

const RoleSelectionWrapper = ({ children }) => {
  const { user, loading, needsRoleSelection, updateUserRole } = UserAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Only show role selection for Google users who don't have a role
  // Email users will have selected their role during signup
  if (user && needsRoleSelection && user.providerData && user.providerData[0]?.providerId === 'google.com') {
    return (
      <RoleSelection
        user={user}
        onRoleSelect={updateUserRole}
      />
    );
  }

  return children;
};

export default RoleSelectionWrapper;
